import { SvgIcon } from '@mui/material';

const DocumentNav = () => (
  <SvgIcon
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 25, fill: 'none' }}
    data-testid="documentNavIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4.65317H8C7.11634 4.65317 6.4 5.36952 6.4 6.25317V17.2532C6.4 18.1368 7.11634 18.8532 8 18.8532H16C16.8837 18.8532 17.6 18.1368 17.6 17.2532V6.25317C17.6 5.36952 16.8837 4.65317 16 4.65317ZM8 3.25317C6.34315 3.25317 5 4.59632 5 6.25317V17.2532C5 18.91 6.34315 20.2532 8 20.2532H16C17.6569 20.2532 19 18.91 19 17.2532V6.25317C19 4.59632 17.6569 3.25317 16 3.25317H8ZM8 16.0531C8 15.6665 8.3134 15.3531 8.7 15.3531H15.3C15.6866 15.3531 16 15.6665 16 16.0531C16 16.4397 15.6866 16.7531 15.3 16.7531H8.7C8.3134 16.7531 8 16.4397 8 16.0531ZM8.7 12.3531C8.3134 12.3531 8 12.6665 8 13.0531C8 13.4397 8.3134 13.7531 8.7 13.7531H15.3C15.6866 13.7531 16 13.4397 16 13.0531C16 12.6665 15.6866 12.3531 15.3 12.3531H8.7ZM8 10.0531C8 9.66655 8.3134 9.35315 8.7 9.35315H15.3C15.6866 9.35315 16 9.66655 16 10.0531C16 10.4397 15.6866 10.7531 15.3 10.7531H8.7C8.3134 10.7531 8 10.4397 8 10.0531ZM8.7 6.35315C8.3134 6.35315 8 6.66655 8 7.05315C8 7.43975 8.3134 7.75315 8.7 7.75315H15.3C15.6866 7.75315 16 7.43975 16 7.05315C16 6.66655 15.6866 6.35315 15.3 6.35315H8.7Z"
      fill="#4D5160"
    />
  </SvgIcon>
);

export default DocumentNav;
